import React, { useMemo } from 'react';
import { buildUiHelpers } from './sharedUi';

export default function SupportSection({
  isAdmin,
  COLORS,
  inputStyle,
  themeMode,
  supportTickets,
  supportTicketTotal,
  supportTicketOffset,
  supportTicketLimit,
  supportDetail,
  supportLoading,
  supportErr,
  supportMsg,
  supportStatusFilter,
  setSupportStatusFilter,
  supportDeleteConfirmText,
  setSupportDeleteConfirmText,
  supportSubject,
  setSupportSubject,
  supportCategory,
  setSupportCategory,
  supportMessage,
  setSupportMessage,
  supportReply,
  setSupportReply,
  supportStatusValue,
  setSupportStatusValue,
  SUPPORT_CATEGORIES,
  SUPPORT_STATUSES,
  ladeSupportTickets,
  ladeSupportTicketDetail,
  supportTicketErstellen,
  supportAntwortSenden,
  supportStatusSpeichern,
  supportTicketLoeschen,
  supportTicketSchliessen,
}) {
  const { Card, Btn, Badge } = useMemo(() => buildUiHelpers({ COLORS, th: {} }), [COLORS]);
  const supportPageStart = supportTickets.length > 0 ? supportTicketOffset + 1 : 0;
  const supportPageEnd = supportTicketOffset + supportTickets.length;
  const canGoBack = supportTicketOffset > 0;
  const canGoForward = supportPageEnd < supportTicketTotal;

  return (
    <div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '20px' }}>
        <Card>
          <div style={{ fontSize: '16px', fontWeight: '700', marginBottom: '12px' }}>
            {isAdmin ? 'Neues Ticket / Übersicht' : 'Neues Ticket'}
          </div>
          <label style={{ fontSize: '12px', color: COLORS.muted, display: 'block', marginBottom: '6px' }}>Betreff</label>
          <input
            style={inputStyle}
            autoComplete="off"
            value={supportSubject}
            onChange={e => setSupportSubject(e.target.value)}
            placeholder="Kurze Beschreibung des Anliegens"
          />
          <label style={{ fontSize: '12px', color: COLORS.muted, display: 'block', marginBottom: '6px' }}>Kategorie</label>
          <select
            style={{ ...inputStyle, appearance: 'none' }}
            value={supportCategory}
            onChange={e => setSupportCategory(e.target.value)}
          >
            {SUPPORT_CATEGORIES.map(category => (
              <option key={category} value={category}>{category}</option>
            ))}
          </select>
          <label style={{ fontSize: '12px', color: COLORS.muted, display: 'block', marginBottom: '6px' }}>Nachricht</label>
          <textarea
            value={supportMessage}
            onChange={e => setSupportMessage(e.target.value)}
            style={{
              width: '100%',
              minHeight: '140px',
              background: themeMode === 'light' ? '#f7fbfd' : '#0b0d12',
              color: COLORS.text,
              border: `1px solid ${COLORS.border}`,
              borderRadius: '10px',
              padding: '12px',
              boxSizing: 'border-box',
              resize: 'vertical',
              fontSize: '14px',
              marginBottom: '12px',
            }}
            placeholder="Beschreibe dein Anliegen oder Problem"
          />
          <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginBottom: '12px' }}>
            <Btn onClick={supportTicketErstellen} color="green" size="sm">Ticket erstellen</Btn>
            <Btn onClick={() => ladeSupportTickets()} color="ghost" size="sm">Aktualisieren</Btn>
          </div>
          {supportErr && <div style={{ color: COLORS.red, fontSize: '13px', marginBottom: '10px' }}>⚠ {supportErr}</div>}
          {supportMsg && <div style={{ color: COLORS.green, fontSize: '13px', marginBottom: '10px' }}>✓ {supportMsg}</div>}
          <div style={{ fontSize: '15px', fontWeight: '700', marginBottom: '10px' }}>
            {isAdmin ? 'Alle Tickets' : 'Meine Tickets'}
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '10px', flexWrap: 'wrap', marginBottom: '10px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
              <div style={{ color: COLORS.muted, fontSize: '12px' }}>
                {supportTicketTotal > 0
                  ? `${supportPageStart}-${supportPageEnd} von ${supportTicketTotal} Tickets`
                  : 'Keine Tickets'}
              </div>
              <div style={{ display: 'inline-flex', gap: '6px', padding: '4px', borderRadius: '999px', border: `1px solid ${COLORS.border}`, background: '#ffffff05' }}>
                <button
                  onClick={() => setSupportStatusFilter('open')}
                  style={{
                    border: 'none',
                    borderRadius: '999px',
                    padding: '6px 10px',
                    fontSize: '12px',
                    fontWeight: '700',
                    cursor: 'pointer',
                    background: supportStatusFilter === 'open' ? COLORS.accent : 'transparent',
                    color: supportStatusFilter === 'open' ? '#fff' : COLORS.muted,
                  }}
                >
                  Offen
                </button>
                <button
                  onClick={() => setSupportStatusFilter('closed')}
                  style={{
                    border: 'none',
                    borderRadius: '999px',
                    padding: '6px 10px',
                    fontSize: '12px',
                    fontWeight: '700',
                    cursor: 'pointer',
                    background: supportStatusFilter === 'closed' ? COLORS.accent : 'transparent',
                    color: supportStatusFilter === 'closed' ? '#fff' : COLORS.muted,
                  }}
                >
                  Geschlossen
                </button>
              </div>
            </div>
            <div style={{ display: 'flex', gap: '8px' }}>
              <Btn onClick={() => ladeSupportTickets(null, Math.max(0, supportTicketOffset - supportTicketLimit))} color="ghost" size="sm" disabled={!canGoBack}>
                Zurück
              </Btn>
              <Btn onClick={() => ladeSupportTickets(null, supportTicketOffset + supportTicketLimit)} color="ghost" size="sm" disabled={!canGoForward}>
                Weiter
              </Btn>
            </div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            {supportLoading && <div style={{ color: COLORS.muted, fontSize: '13px' }}>Lade Tickets...</div>}
            {!supportLoading && supportTickets.length === 0 && (
              <div style={{ color: COLORS.muted, fontSize: '13px' }}>Noch keine Tickets vorhanden.</div>
            )}
            {supportTickets.map(ticket => (
              <button
                key={ticket.id}
                onClick={() => ladeSupportTicketDetail(ticket.id)}
                style={{
                  textAlign: 'left',
                  border: `1px solid ${supportDetail?.id === ticket.id ? COLORS.cyan : COLORS.border}`,
                  background: supportDetail?.id === ticket.id ? '#164e6344' : '#ffffff05',
                  color: COLORS.text,
                  borderRadius: '10px',
                  padding: '12px',
                  cursor: 'pointer',
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: '8px', marginBottom: '6px' }}>
                  <div style={{ fontWeight: '700', fontSize: '13px' }}>{ticket.subject}</div>
                  <Badge color={ticket.status === 'geschlossen' ? 'red' : ticket.status === 'beantwortet' ? 'green' : 'yellow'}>
                    {ticket.status}
                  </Badge>
                </div>
                <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', marginBottom: '6px' }}>
                  <Badge color="ghost">{ticket.category}</Badge>
                  {isAdmin && ticket.user_email && <Badge color="indigo">{ticket.user_email}</Badge>}
                </div>
                <div style={{ color: COLORS.muted, fontSize: '12px', lineHeight: 1.6 }}>
                  {ticket.last_message_preview || 'Noch keine Nachricht'}
                </div>
              </button>
            ))}
          </div>
        </Card>

        <Card>
          {!supportDetail && (
            <div style={{ color: COLORS.muted, fontSize: '14px' }}>
              Wähle ein Ticket aus oder erstelle ein neues Ticket.
            </div>
          )}

          {supportDetail && (
            <>
              <div style={{ display: 'flex', justifyContent: 'space-between', gap: '12px', alignItems: 'flex-start', marginBottom: '12px', flexWrap: 'wrap' }}>
                <div>
                  <div style={{ fontSize: '18px', fontWeight: '700', marginBottom: '6px' }}>{supportDetail.subject}</div>
                  <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                    <Badge color="ghost">{supportDetail.category}</Badge>
                    <Badge color={supportDetail.status === 'geschlossen' ? 'red' : supportDetail.status === 'beantwortet' ? 'green' : 'yellow'}>
                      {supportDetail.status}
                    </Badge>
                    {supportDetail.user_email && <Badge color="indigo">{supportDetail.user_email}</Badge>}
                  </div>
                </div>
                {isAdmin && (
                  <div style={{ minWidth: '190px' }}>
                    <label style={{ fontSize: '12px', color: COLORS.muted, display: 'block', marginBottom: '6px' }}>Status</label>
                    <div style={{ display: 'flex', gap: '8px' }}>
                      <select
                        style={{ ...inputStyle, marginBottom: 0, flex: 1, appearance: 'none' }}
                        value={supportStatusValue}
                        onChange={e => setSupportStatusValue(e.target.value)}
                      >
                        {SUPPORT_STATUSES.map(status => (
                          <option key={status} value={status}>{status}</option>
                        ))}
                      </select>
                      <Btn onClick={supportStatusSpeichern} color="ghost" size="sm">Speichern</Btn>
                    </div>
                  </div>
                )}
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '16px' }}>
                {supportDetail.messages.map(message => (
                  <div
                    key={message.id}
                    style={{
                      padding: '12px 14px',
                      borderRadius: '12px',
                      background: message.is_admin ? '#164e6344' : '#ffffff05',
                      border: `1px solid ${message.is_admin ? COLORS.cyan + '44' : COLORS.border}`,
                    }}
                  >
                    <div style={{ display: 'flex', justifyContent: 'space-between', gap: '8px', marginBottom: '6px', flexWrap: 'wrap' }}>
                      <div style={{ fontSize: '12px', fontWeight: '700', color: message.is_admin ? COLORS.cyan : COLORS.text }}>
                        {message.is_admin ? 'Support' : (message.author_email || 'Benutzer')}
                      </div>
                      <div style={{ fontSize: '12px', color: COLORS.muted }}>
                        {new Date(message.created_at).toLocaleString('de-DE')}
                      </div>
                    </div>
                    <div style={{ color: COLORS.text, fontSize: '14px', lineHeight: 1.7, whiteSpace: 'pre-wrap' }}>
                      {message.message}
                    </div>
                  </div>
                ))}
              </div>

              <label style={{ fontSize: '12px', color: COLORS.muted, display: 'block', marginBottom: '6px' }}>Antwort</label>
              <textarea
                value={supportReply}
                onChange={e => setSupportReply(e.target.value)}
                style={{
                  width: '100%',
                  minHeight: '110px',
                  background: themeMode === 'light' ? '#f7fbfd' : '#0b0d12',
                  color: COLORS.text,
                  border: `1px solid ${COLORS.border}`,
                  borderRadius: '10px',
                  padding: '12px',
                  boxSizing: 'border-box',
                  resize: 'vertical',
                  fontSize: '14px',
                  marginBottom: '12px',
                }}
                placeholder={isAdmin ? 'Antwort an den Benutzer schreiben…' : 'Weitere Rückfrage oder Rückmeldung…'}
              />
              <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center' }}>
                <Btn onClick={supportAntwortSenden} color="green" size="sm">Antwort senden</Btn>
                {!isAdmin && (
                  <div style={{ marginLeft: 'auto' }}>
                    <Btn
                      onClick={supportTicketSchliessen}
                      color="ghost"
                      size="sm"
                      disabled={supportDetail.status === 'geschlossen'}
                    >
                      Ticket schließen
                    </Btn>
                  </div>
                )}
              </div>
              {isAdmin ? (
                <div style={{ marginTop: '16px', padding: '12px', borderRadius: '12px', border: `1px solid ${COLORS.border}`, background: '#ffffff04' }}>
                  <div style={{ fontSize: '12px', color: COLORS.muted, marginBottom: '8px' }}>
                    Zum Löschen bitte genau <strong>löschen</strong> eingeben.
                  </div>
                  <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center' }}>
                    <input
                      style={{ ...inputStyle, marginBottom: 0, minWidth: '180px', flex: '1 1 220px' }}
                      autoComplete="off"
                      value={supportDeleteConfirmText}
                      onChange={e => setSupportDeleteConfirmText(e.target.value)}
                      placeholder="löschen"
                    />
                    <Btn
                      onClick={supportTicketLoeschen}
                      color="red"
                      size="sm"
                      disabled={supportDeleteConfirmText.trim().toLowerCase() !== 'löschen'}
                    >
                      Ticket löschen
                    </Btn>
                  </div>
                </div>
              ) : null}
            </>
          )}
        </Card>
      </div>
    </div>
  );
}
